import Layout from '@/views/layout';

const achievementRouter = {
  path: '/achievement',
  name: 'Achievement',
  component: Layout,
  meta: { title: '业绩', roles: [0, 1, 2, 3, 4], noCache: true },
  redirect: { name: 'AchievementList' },
  children: [
    {
      path: 'achievementlist',
      name: 'AchievementList',
      component: () => import('@/views/achievement'),
      meta: { title: '业绩', roles: [0, 1, 2, 3, 4], noCache: true }
    }
  ]
}

export default achievementRouter;